import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from 'src/app/services/login/login.service';

@Injectable()
export class SharedDataService {
  title: string;
  tempPassword: string;
  username: string;
  allBuildingDetails = new Map();
  communityUnitTypeData = new Map();
  allCareTypesForUnitTypes;
  communitiesBaseUrl = environment.environmentDetails + 'community-service/rest/communityservice/';

  closeResult: string;

  careALType = new Set(['assistedLivingBaseRent', 'assistedLivingSecBaseRent', 'assistedLivingSplitBaseRent',
    'respiteAssistedLivingBaseRent', 'respiteAssistedLivingSecBaseRent', 'respiteAssistedLivingSplitBaseRent']);
  careILType = new Set(['independentLivingBaseRent', 'independentLivingSecBaseRent', 'independentLivingSplitBaseRent',
    'respiteIndependentLivingBaseRent', 'respiteIndependentLivingSecBaseRent', 'respiteIndependentLivingSplitBaseRent']);
  careMCType = new Set(['memoryCareBaseRent', 'memoryCareSecBaseRent', 'memoryCareSplitBaseRent',
    'respiteMemoryCareBaseRent', 'respiteMemoryCareSecBaseRent', 'respiteMemoryCareSplitBaseRent']);

  listOfPermissions: string[];
  private unsubscribe = new Subject();

  constructor(private http: HttpClient, private modalService: NgbModal,
    private loginService: LoginService) {
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  checkPermission(permissionName) {
    if (!this.listOfPermissions) {
      this.loginService.currentUser$.pipe(takeUntil(this.unsubscribe)).subscribe(user => {
        this.listOfPermissions = user?.role.permissions.map(permission => permission.permissionCode)
      })
    }
    return this.listOfPermissions ? this.listOfPermissions.some(permission => permission == permissionName) : false;
  }

  private isResidentHaveFinancialPOA = new BehaviorSubject('');
  isResidentHaveFinancialPOAValue = this.isResidentHaveFinancialPOA.asObservable();

  changeIsResidentHaveFinancialPOAValue(message: string) {
    this.isResidentHaveFinancialPOA.next(message);
  }

  private isResidentHaveHealthcarePOA = new BehaviorSubject('');
  isResidentHaveHealthcarePOAValue = this.isResidentHaveHealthcarePOA.asObservable();

  changeIsResidentHaveHealthcarePOAValue(message: string) {
    this.isResidentHaveHealthcarePOA.next(message);
  }

  //EmergencyContact
  private isResidentHaveEmergencyContact = new BehaviorSubject('');
  isResidentHaveEmergencyContactValue = this.isResidentHaveEmergencyContact.asObservable();

  changeIsResidentHaveEmergencyContactValue(message: string) {
    this.isResidentHaveEmergencyContact.next(message);
  }

  private dateFormFilterData = new BehaviorSubject([]);
  dateFormFilterDataValue = this.dateFormFilterData.asObservable();

  changeDateFormFilterDataValue(message: any) {
    this.dateFormFilterData.next(message);
  }

  private custUserNameDetails = new BehaviorSubject('');
  custUserNameDetailsValue = this.custUserNameDetails.asObservable();

  private narrowSideNavActive = new BehaviorSubject(false);
  isNarrowSideNavActive = this.narrowSideNavActive.asObservable();

  changeCustUserNameDetailsValue(message: any) {
    this.custUserNameDetails.next(message);
  }

  private custRoleDetails = new BehaviorSubject('');
  custRoleDetailsValue = this.custRoleDetails.asObservable();

  changecUstRoleDetailsValue(message: any) {
    this.custRoleDetails.next(message);
  }

  private selectedResidentType = new BehaviorSubject('');
  selectedResidentTypeValue = this.selectedResidentType.asObservable();

  changeSelectedResidentTypeValue(message: any) {
    this.selectedResidentType.next(message);
  }

  private residentSpouseDetails = new BehaviorSubject([]);
  residentSpouseDetailsValue = this.residentSpouseDetails.asObservable();

  private isResidentActive = new BehaviorSubject(false);
  isResidentActiveValue = this.isResidentActive.asObservable();

  changeIsResidentActiveValue(message: any) {
    this.isResidentActive.next(message);
  }

  changeResidentSpouseDetailsValue(message: any) {
    this.residentSpouseDetails.next(message);
  }

  private isCommunityConfigured = new BehaviorSubject('');
  isCommunityConfiguredValue = this.isCommunityConfigured.asObservable();

  changeIsCommunityConfiguredValue(message: any) {
    this.isCommunityConfigured.next(message);
  }

  setChangePasswordHeader(label: string): void {
    this.title = label;
  }

  getChangePasswordHeader(): string {
    return this.title;
  }

  setTempPassword(pwd: string): void {
    this.tempPassword = pwd;
  }

  getTempPassword(): string {
    return this.tempPassword;
  }

  setUserName(name: string): void {
    this.username = name;
  }

  getUserName(): string {
    return this.username;
  }

  getProfileDetails(userName, firstname, lastname, role): string {
    //let profileDetails = 'Logged In as:' + ' ' + firstname + ' ' + lastname;
    let profileDetails = 'Logged in as:' + ' ' + userName;
    profileDetails = profileDetails + '   ' + '&nbsp; | ' + '&nbsp; Role:' + '  ' + role;
    return profileDetails;
  }

  activeNarrowSideNav(status) {
    this.narrowSideNavActive.next(status);
  }

  private secondaryResident = new BehaviorSubject('');
  secondaryResident$ = this.secondaryResident.asObservable();

  changeSecondaryResident(message: string) {
    this.secondaryResident.next(message);
  }

  private isAccountView = new BehaviorSubject('false');
  isAccountViewValue = this.isAccountView.asObservable();

  changeIsAccountViewValue(message: string) {
    this.isAccountView.next(message);
  }

  private isRefreshOffSite = new BehaviorSubject(false);
  isRefreshOffSiteValue = this.isRefreshOffSite.asObservable();

  changeIsRefreshOffSite(data: any) {
    this.isRefreshOffSite.next(data);
  }

  private selectedResidentMenuItemSelected = new BehaviorSubject('');
  currentSelectedResidentMenuItemSelected = this.selectedResidentMenuItemSelected.asObservable();

  changeSelectedResidentMenuItemSelected(message: string) {
    this.selectedResidentMenuItemSelected.next(message);
  }

  private selectedHealthMenuItemSelected = new BehaviorSubject('');
  currentSelectedHealthMenuItemSelected = this.selectedHealthMenuItemSelected.asObservable();

  changeSelectedHealthMenuItemSelected(message: string) {
    this.selectedHealthMenuItemSelected.next(message);
  }

  private residentContactData = new BehaviorSubject({});
  residentContactDataValue = this.residentContactData.asObservable();

  sendResidentContactData(data: any) {
    this.residentContactData.next(data);
  }

  private dispalyMissedComponent = new BehaviorSubject(false);
  dispalyMissedComponentValue = this.dispalyMissedComponent.asObservable();

  setDispalyMissedComponent(value: boolean) {
    this.dispalyMissedComponent.next(value);
  }

  private dispalyHealthNotification = new BehaviorSubject(false);
  dispalyHealthNotificationValue = this.dispalyHealthNotification.asObservable();

  setDispalyHealthNotification(value: boolean) {
    this.dispalyHealthNotification.next(value);
  }

  private dispalyDashboardNotification = new BehaviorSubject(false);
  dispalyDashboardNotificationValue = this.dispalyDashboardNotification.asObservable();

  setDispalyDashboardNotification(value: boolean) {
    this.dispalyDashboardNotification.next(value);
  }

  private displayNotificationIcon = new BehaviorSubject(true);
  displayNotificationIconValue = this.displayNotificationIcon.asObservable();

  setDispalyNotificationIcon(value: boolean) {
    this.displayNotificationIcon.next(value);
  }

  private selectedCareItemsData = new BehaviorSubject([]);
  selectedCareItemsDataValue = this.selectedCareItemsData.asObservable();

  changeSelectedCareItemsData(data: any) {
    this.selectedCareItemsData.next(data);
  }

  private selectedCareInputesData = new BehaviorSubject({});
  selectedCareInputesDataValue = this.selectedCareInputesData.asObservable();

  changeSelectedCareInputData(data: any) {
    this.selectedCareInputesData.next(data);
  }

  private communityLogoUrl = new BehaviorSubject('');
  communityLogoUrl$ = this.communityLogoUrl.asObservable();

  changeCommunityLogoUrl(data: any) {
    this.communityLogoUrl.next(data);
  }

  private residentGeneralData = new BehaviorSubject('');
  residentGeneralData$ = this.residentGeneralData.asObservable();

  changeResidentGeneralDataValue(value: any) {
    this.residentGeneralData.next(value);
  }

  private residentFeesDetails = new BehaviorSubject('');
  residentFeesDetailsValue = this.residentFeesDetails.asObservable();

  changeResidentFeesDetailsValue(value: any) {
    this.residentFeesDetails.next(value);
  }

  private userActivity;
  private userActivityLogOut;
  userInactive: Subject<any> = new Subject();
  userInactiveLogOut: Subject<any> = new Subject();

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), environment.idleTime * 1000);
    this.userActivityLogOut = setTimeout(() => this.userInactiveLogOut.next(undefined), ((environment.idleTime * 1000) + (environment.timeoutTime * 1000)));
  }

  clearTimeout() {
    clearTimeout(this.userActivity);
    clearTimeout(this.userActivityLogOut);
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), environment.idleTime * 1000);
    this.userActivityLogOut = setTimeout(() => this.userInactiveLogOut.next(undefined), ((environment.idleTime * 1000) + (environment.timeoutTime * 1000)));
  }

  checkPhoneNumber(element) {
    const regExpr = /[^0-9-. ]/g;
    const userText = element.target.value;
    if (element.keyCode == 8) {
      return;
    }
    let num = userText.replace(regExpr, '-');
    num = num.split('-').join('');
    const finalVal = num.length > 1 ? num.substring(0, 3) + (num.length > 3 ? '-' : '')
      + num.substring(3, 6) + (num.length > 5 ? '-' : '') + num.substring(6, num.length) : num;
    element.target.value = finalVal;
  }

  checkEINNumber(element) {
    const regExpr = /[^0-9-. ]/g;
    const userText = element.target.value;
    if (element.keyCode == 8) {
      return;
    }
    let num = userText.replace(regExpr, '-');
    num = num.split('-').join('');
    const finalVal = num.length > 1 ? num.substring(0, 2) + (num.length > 2 ? '-' : '') +
      num.substring(2, 9)
      + num.substring(9, num.length) : num;
    element.target.value = finalVal;
  }

  getEINNumber(userData): string {
    if (userData) {
      const regExpr = /[^0-9-. ]/g;
      const userText = userData;
      let num = userText.replace(regExpr, '-');
      num = num.split('-').join('');
      const index = num.length >= 9 ? num.length - 9 : 1;
      num = num.slice(index, num.length);
      const finalVal = num.length > 1 ? num.substring(0, 2) + (num.length > 2 ? '-' : '')
        + num.substring(2, 9) + num.substring(9, num.length) : num;
      return finalVal;
    }
  }

  async getUnitTypeMapForBuilding(buildingId, communityId) {
    if (!this.allCareTypesForUnitTypes) {
      console.log(`Getting care types for unit types of building ${communityId} from API`);

      const formData = new FormData();
      formData.append('communityId', communityId)

      const response = await this.http.post<any>(this.communitiesBaseUrl + 'getCareTypesForUnitTypes', formData).toPromise();
      this.allCareTypesForUnitTypes = new Map<Number, Map<Number, any>>();

      for (const item of response.data) {
        const buildingId = item[0];
        const buildingMap = new Map<Number, any>(item[1]);
        this.allCareTypesForUnitTypes.set(buildingId, buildingMap);
      }
    }

    return this.allCareTypesForUnitTypes.get(Number(buildingId));
  }

  async getFloorPlanData(buildingId) {
    let floorPlanData = this.allBuildingDetails.get(buildingId);
    if (!floorPlanData) {
      const response = await this.http.post<any>(this.communitiesBaseUrl + 'getFloorPlanData', { buildingId: buildingId }).toPromise();

      floorPlanData = response.data;
      for (const floor of floorPlanData) {
        const unitMap = new Map();
        const unitTypeColors = new Map();
        for (const unitType of floor.unitListInFloorPlan) {
          unitTypeColors.set(unitType.unitTypeId, unitType.backgroundColor);
          for (const unit of unitType.unitList) {
            unit.color = 'white'; // default no-color
            unit.unitTypeId = unitType.unitTypeId;
            unitMap.set(unit.id, unit);
            if (unit.roomList) {
              for (const room of unit.roomList) {
                room.color = unitType.backgroundColor;
              }
            }
          }
        }
        floor.unitMap = unitMap;
        floor.unitTypeColors = unitTypeColors;
      }
      this.allBuildingDetails.set(buildingId, floorPlanData);
      return floorPlanData;
    } else {
      console.log(`Returning already loaded floor plan data of building ${buildingId} having ${floorPlanData.length} floors`);
      return floorPlanData;
    }
  }

  isResponseValid(response): boolean {
    if (response === null || response === undefined) {
      return false;
    } else {
      return response.status === 1;
    }
  }

  clearCachedData(): void {
    this.allBuildingDetails.clear();
    this.allCareTypesForUnitTypes = undefined;
  }

  openModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  setCommunityUnitTypeData(buildings) {
    for (const building of buildings) {
      let buildingId = building.id;
      let careALTypeCount = 0;
      let careILTypeCount = 0;
      let careMCTypeCount = 0;
      for (let floor of building.floorsAndImageIds) {
        for (let unitType of floor.unitTypeList) {
          for (const rentKey in unitType.careTypeList[0]) {
            if (this.careALType.has(rentKey)) {
              careALTypeCount = careALTypeCount + 1;
            } else if (this.careILType.has(rentKey)) {
              careILTypeCount = careILTypeCount + 1;
            } else {
              careMCTypeCount = careMCTypeCount + 1;
            }
          }
        }
      }
      const count = new Map();
      count.set('ALCount', careALTypeCount);
      count.set('ILCount', careILTypeCount);
      count.set('MCCount', careMCTypeCount);
      this.communityUnitTypeData.set(buildingId, count);
    }
  }

  isBuildingILonly(buildingId) {
    let counts = this.communityUnitTypeData.get(buildingId)
    if (counts.get('ALCount') > 0 || counts.get('MCCount') > 0) {
      return false;
    } else {
      return true;
    }
  }
}
